import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import APIs from "../../APIs";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation(); // current path
  const [user, setUser] = useState(null);

  // Get user data from session
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const user_id = userData?.user_id;

  // Fetch user info
  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (!user_id) return;

        const res = await APIs.post(
          "user/getUserById",
          { user_id },
          { headers: { "Content-Type": "application/json" } }
        );

        setUser(res.data?.data || null);
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };

    fetchUser();
  }, [user_id]);

  // Loading state
  // if (!user) {
  //   return (
  //     <div className="page-content">
  //       <div className="container text-center py-5">
  //         <p>Loading profile...</p>
  //       </div>
  //     </div>
  //   );
  // }

  // Sidebar menu items
  const menuItems = [
    {
      path: "/mybookings",
      icon: "ti-calendar",
      label: "My Booking",
      activePaths: ["/mybookings", "/Dashboard","/dashboard", "/bookingdetails"],
    },
    {
      path: "/quotation",
      icon: "ti-heart",
      label: "My Quotation",
      activePaths: ["/quotation", "/quotationdetails"],
    },
    { path: "/myprofile", icon: "ti-user", label: "My Profile" },
    { path: "/mypayment", icon: "ti-credit-card", label: "Payment" },
    { path: "/notification", icon: "ti-bell", label: "Notifications" },
    { path: "/chatlist", icon: "ti-comments", label: "Chat List" },
    { path: "/myaddress", icon: "ti-map", label: "Address", 
      activePaths: ["/myaddress","/newaddress"]},
{ path: "/changepassword", icon: "fa fa-key", label: "Change Password" },

  ];

  // Function to check if menu is active
  const isMenuActive = (item) => {
    if (item.activePaths && item.activePaths.length) {
      return item.activePaths.some((path) => location.pathname.startsWith(path));
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <div
      className="admin-sidebar-container offcanvas offcanvas-start"
      tabIndex="-1"
      id="offcanvasExample"
      aria-labelledby="offcanvasExampleLabel"
    >
      <button
        type="button"
        className="btn-close text-reset d-block d-lg-none"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>

      <div className="admin-sidebar">
        {/* Profile Section */}
        <div className="profile-section">
          <div className="profile-img">
            <img
              src={user?.profile_image || "/images/img-01.png"}
              className="img-fluid"
              alt={user?.full_name || "user"}
              id="user-avtar-leftmenu"
            />
          </div>
          <div className="profile">
            <div className="profile-name">{user?.full_name || "user"}</div>
            <Link className="edit-profile" to="/editprofile">
              Edit profile
            </Link>
          </div>
        </div>

        {/* Sidebar Menu */}
        <ul className="fb-left-bar-menus">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link to={item.path} className={isMenuActive(item) ? "active" : ""}>
                <i className={item.icon}></i> {item.label}
              </Link>
            </li>
          ))}

          {/* Logout */}
         <li>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              Swal.fire({
                text: "Are you sure you want to log out?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, log me out!",
              }).then((result) => {
                if (result.isConfirmed) {
                  localStorage.clear();
                  sessionStorage.clear();
                  toast.success("Logged out successfully!", { position: "top-right" });
                  navigate("/");
                  window.location.reload();
                }
              });
            }}
          >
            <i className="fa fa-sign-in" aria-hidden="true"></i> Log Out
          </a>
        </li>


        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
